import { ExternalGeoEvent } from 'shared/types';
import { ExternalGeoEventFields } from './ExternalGeoEventFields';
import { ExternalGeoEventLocation } from './ExternalGeoEventLocation';

type ExternalGeoEventInfoProps = {
  event: ExternalGeoEvent;
};

export const ExternalGeoEventInfo = (
  props: ExternalGeoEventInfoProps,
): JSX.Element => {
  const { event } = props;

  return (
    <>
      <ExternalGeoEventFields event={event} />
      <ExternalGeoEventLocation event={event} />
    </>
  );
};
